document.addEventListener('DOMContentLoaded', initProjectsGallery);

function initProjectsGallery() {
  document.querySelectorAll('.wp-block-tema99-projects-gallery').forEach(initQueryProjectBlock);
}

function initQueryProjectBlock(block) {

  const filterChips = block.querySelectorAll('.filter-chip');
  const projectsGrid = block.querySelector('.projects-grid');
  let activeFilters = [];

  const statoLavoroTerms = block.dataset.statoLavoroTerms ? JSON.parse(block.dataset.statoLavoroTerms) : [];

  // Check se URL ha la query 'tipo-costruzione'
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.has('tipo-costruzione')) {
    activeFilters = urlParams.get('tipo-costruzione').split(',');
    aggiornaFiltri(block, filterChips, activeFilters);
  } else {
    // Diversamente - nessun filtro attivo
    aggiornaFiltri(block, filterChips, activeFilters);
    // Fetch progetti senza filtri
    fetchProjects(block, projectsGrid, activeFilters, statoLavoroTerms);
  }

  // Toggle su chip
  block.addEventListener('click', event => {
    const chip = event.target.closest('.filter-chip');
    if (!chip || !block.contains(chip)) return;

    if (chip.dataset.action === 'reset') {
      rimuoviTuttiFiltri(block, activeFilters, projectsGrid, statoLavoroTerms);
      return;
    }

    if (chip.classList.contains('active')) {
      // Rimuovi
      rimuoviFiltro(block, chip, activeFilters, projectsGrid, statoLavoroTerms);
    } else {
      // Aggiungi
      aggiungiFiltro(block, chip, activeFilters, projectsGrid, statoLavoroTerms);
    }
  });
}

function aggiornaFiltri(block, filterChips, activeFilters) {
  filterChips.forEach(chip => {
    const term = chip.dataset.term;
    if (activeFilters.includes(term)) {
      chip.classList.add('active');

    } else {
      chip.classList.remove('active');
      const removeBtn = chip.querySelector('.remove-filter');
      if (removeBtn) removeBtn.remove();
    }
  });
}

function aggiungiFiltro(block, chipElement, activeFilters, projectsGrid, statoLavoroTerms) {
  const term = chipElement.dataset.term;

  if (!activeFilters.includes(term)) {
    activeFilters.push(term);

    // Se è un termine padre, attiva anche i suoi figli
    if (chipElement.classList.contains('parent-term')) {
      const childTerms = block.querySelectorAll(`.child-term[data-parent="${term}"]`);
      childTerms.forEach(childTerm => {
        const childTermSlug = childTerm.dataset.term;
        if (!activeFilters.includes(childTermSlug)) {
          activeFilters.push(childTermSlug);
        }
      });
    }

    // Fetch progetti
    aggiornaFiltri(block, block.querySelectorAll('.filter-chip'), activeFilters);
    fetchProjects(block, projectsGrid, activeFilters, statoLavoroTerms);
  }
}

function rimuoviFiltro(block, chipElement, activeFilters, projectsGrid, statoLavoroTerms) {
  const term = chipElement.dataset.term;

  const index = activeFilters.indexOf(term);
  if (index > -1) {
    activeFilters.splice(index, 1);
  }

  // Se è un termine padre, rimuovi anche i suoi figli
  if (chipElement.classList.contains('parent-term')) {
    const childTerms = block.querySelectorAll(`.child-term[data-parent="${term}"]`);
    childTerms.forEach(childTerm => {
      const childTermSlug = childTerm.dataset.term;
      const childIndex = activeFilters.indexOf(childTermSlug);
      if (childIndex > -1) {
        activeFilters.splice(childIndex, 1);
      }
    });
  }

  aggiornaFiltri(block, block.querySelectorAll('.filter-chip'), activeFilters);
  fetchProjects(block, projectsGrid, activeFilters, statoLavoroTerms);
}

function fetchProjects(block, projectsGrid, activeFilters, statoLavoroTerms) {

  projectsGrid.classList.add('loading');

  const params = new URLSearchParams();
  if (activeFilters.length > 0) {
    params.set('terms', activeFilters.join(','));
  }
  if (statoLavoroTerms && statoLavoroTerms.length > 0) {
    params.set('stato_lavoro', statoLavoroTerms.join(','));
  }

  const url = new URL(window.location);
  if (activeFilters.length > 0) {
    url.searchParams.set('tipo-costruzione', activeFilters.join(','));
  } else {
    url.searchParams.delete('tipo-costruzione');
  }
  window.history.pushState({}, '', url);

  // REST richiesta
  fetch(`/wp-json/t99/v1/projects${params.toString() ? `?${params.toString()}` : ''}`)
    .then(response => response.json())
    .then(data => {
      projectsGrid.innerHTML = data && data.html
        ? data.html
        : '<div class="no-projects">Error loading projects.</div>';
      setTimeout(() => {
        projectsGrid.classList.remove('loading');
      }, 100);
    })
    .catch(error => {
      console.error('Error:', error);
      projectsGrid.innerHTML = '<div class="no-projects">Error loading projects.</div>';
      projectsGrid.classList.remove('loading');
    });
}

function rimuoviTuttiFiltri(block, activeFilters, projectsGrid, statoLavoroTerms) {
  activeFilters.length = 0;

  aggiornaFiltri(block, block.querySelectorAll('.filter-chip'), activeFilters);
  fetchProjects(block, projectsGrid, activeFilters, statoLavoroTerms);
}